import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { useMemo } from 'react';
import EmailOptionButton from '../../EmailCreation/components/EmailOptionSelection/EmailOptionButton';
import useGetEmailCloneTypeOptions from '../hooks/useGetEmailCloneTypeOptions';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function EmailCloneTypeButtons({
  email,
  selectedEmailType,
  onSelectType
}) {
  const emailTypeOptions = useGetEmailCloneTypeOptions();
  const canChangeEmailType = useMemo(() => !email || email.isBatch() || email.isAutomated(), [email]);
  const tooltip = useMemo(() => {
    if (!canChangeEmailType) {
      if (email.isABLike()) {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "email-management.emailClone.cloneSidePanel.sections.emailType.tooltipForAb"
        });
      }
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "email-management.emailClone.cloneSidePanel.sections.emailType.tooltip"
      });
    }
    return null;
  }, [canChangeEmailType, email]);
  return /*#__PURE__*/_jsx(FormControl, {
    marginBlockStart: "400",
    "data-test-id": "email-type-selectable-buttons",
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      "data-test-id": "email-type-select-modal-email-type-title",
      message: "email-management.emailClone.cloneSidePanel.sections.emailType.label"
    }),
    children: canChangeEmailType ? /*#__PURE__*/_jsx(_Fragment, {
      children: emailTypeOptions.map(option => {
        return /*#__PURE__*/_jsx(EmailOptionButton, {
          emailOption: option,
          onClick: onSelectType,
          isSelected: selectedEmailType === option.type
        }, option.type);
      })
    }) : /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      children: /*#__PURE__*/_jsx(HelpIcon, {
        title: tooltip,
        tooltipPlacement: "right",
        color: "icon-core-subtle",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          "data-test-id": "email-type-can-not-change",
          message: `email-management.emailTypes.${email.emailType}`
        })
      })
    })
  });
}